/** French is the reference catalogue: other languages must provide every key. */
export const fr = {
  'app.name': 'Tablo',
  'app.tagline': 'Schémas électriques pour installateurs',

  'menu.file': 'Fichier',
  'menu.new': 'Nouveau',
  'menu.open': 'Ouvrir…',
  'menu.save': 'Enregistrer',
  'menu.saveAs': 'Enregistrer sous…',
  'menu.export': 'Exporter',
  'menu.exportPdf': 'PDF (toutes les feuilles)',
  'menu.exportSvg': 'SVG (feuille active)',
  'menu.exportPng': 'PNG (feuille active)',
  'menu.print': 'Imprimer…',
  'menu.projectInfo': 'Informations du projet',
  'menu.demo': 'Exemple',
  'menu.benchmark': 'Test de performance',
  'menu.undo': 'Annuler',
  'menu.redo': 'Rétablir',
  'menu.fit': 'Tout afficher',
  'menu.language': 'Langue',
  'menu.copy': 'Copier',
  'menu.cut': 'Couper',
  'menu.paste': 'Coller',
  'menu.duplicate': 'Dupliquer',
  'menu.selectAll': 'Tout sélectionner',

  'tool.select': 'Sélection',
  'tool.wire': 'Fil',
  'tool.text': 'Texte',
  'tool.rotate': 'Pivoter',
  'tool.mirror': 'Miroir',
  'tool.delete': 'Supprimer',

  'sheet.add': 'Nouvelle feuille',
  'sheet.rename': 'Renommer',
  'sheet.delete': 'Supprimer la feuille',
  'sheet.confirmDelete': 'La feuille « {name} » et tout son contenu seront supprimés.',
  'sheet.lastOne': 'Un projet doit garder au moins une feuille.',
  'sheetKind.single-line': 'Schéma unifilaire',
  'sheetKind.multi-line': 'Schéma multifilaire',
  'sheetKind.control': 'Schéma de commande',
  'sheetKind.position-plan': 'Plan de position',
  'sheetKind.board': 'Tableau',

  'status.elements': '{n} éléments',
  'status.wires': '{n} fils',
  'status.zoom': 'Zoom {pct} %',
  'status.platform.desktop': 'Bureau',
  'status.platform.mobile': 'Mobile',
  'status.platform.web': 'Web',
  'status.saved': 'Enregistré',
  'status.unsaved': 'Modifications non enregistrées',
  'status.autosaved': 'Copie de secours à {time}',
  'status.exported': 'Exporté : {name}',

  'panel.selection': 'Sélection',
  'panel.noSelection': 'Rien de sélectionné',
  'panel.multi': '{n} éléments sélectionnés',
  'panel.tag': 'Repère',
  'panel.tagDuplicate': 'Ce repère est déjà utilisé',
  'panel.symbol': 'Symbole',
  'panel.position': 'Position (mm)',
  'panel.rotation': 'Rotation',
  'panel.mirrored': 'Miroir',
  'panel.wire': 'Fil',
  'panel.wireLabel': 'Repère / câble',
  'panel.wireLabelHint': 'ex. XVB 3G2,5',
  'panel.sheet': 'Feuille',
  'panel.sheetName': 'Nom',
  'panel.sheetKind': 'Type de schéma',
  'panel.paper': 'Format',
  'panel.orientation': 'Orientation',
  'panel.landscape': 'Paysage',
  'panel.portrait': 'Portrait',
  'panel.symbols': 'Symboles',
  'panel.search': 'Rechercher un symbole…',
  'panel.noResults': 'Aucun symbole trouvé',
  'panel.allSheets': 'Tous les symboles',

  'cat.protection': 'Protection',
  'cat.distribution': 'Distribution',
  'cat.outlet': 'Prises',
  'cat.appliance': 'Appareils',
  'cat.lighting': 'Éclairage',
  'cat.command': 'Commandes',
  'cat.control': 'Commande / automatisme',
  'cat.motor': 'Moteurs',
  'cat.signalling': 'Signalisation',
  'cat.connection': 'Raccordement',
  'cat.earth': 'Terre',
  'cat.annotation': 'Annotation',

  'meta.title': 'Nom du projet',
  'meta.ownerName': 'Propriétaire',
  'meta.ownerAddress': 'Adresse du propriétaire',
  'meta.installationAddress': "Adresse de l'installation (si différente)",
  'meta.author': 'Auteur du schéma',
  'meta.company': 'Société',
  'meta.date': 'Date',
  'meta.earthingSystem': 'Schéma de liaison à la terre',
  'meta.supplyVoltage': "Tension d'alimentation",
  'meta.locale': 'Langue des schémas',
  'meta.standard': 'Norme',
  'meta.standardHint': 'Règles suivies par le contrôle du projet.',
  'std.rgie': 'RGIE',
  'std.nfc15100': 'NF C 15-100',
  'std.nen1010': 'NEN 1010',
  'std.label.rgie': 'RGIE (Belgique)',
  'std.label.nfc15100': 'NF C 15-100 (France)',
  'std.label.nen1010': 'NEN 1010 (Pays-Bas)',
  'meta.hint': 'Ces informations figurent dans le cartouche de chaque feuille.',

  'tb.project': 'Projet',
  'tb.sheet': 'Feuille',
  'tb.sheetNo': 'N°',
  'tb.owner': 'Propriétaire',
  'tb.date': 'Date',
  'tb.paper': 'Format',
  'tb.installation': "Adresse de l'installation",
  'tb.supply': 'Tension',
  'tb.earthing': 'Liaison à la terre',
  'tb.author': 'Auteur / société',
  'tb.diagram': 'Type de schéma',

  'dialog.ok': 'OK',
  'dialog.cancel': 'Annuler',
  'dialog.close': 'Fermer',
  'dialog.delete': 'Supprimer',
  'dialog.discard': 'Abandonner les modifications',
  'confirm.discard': 'Les modifications non enregistrées seront perdues.',
  'confirm.discardTitle': 'Abandonner les modifications ?',

  'recovery.title': 'Récupérer le travail non enregistré ?',
  'recovery.body': '« {name} » a été modifié le {date} sans être enregistré.',
  'recovery.restore': 'Récupérer',
  'recovery.dismiss': 'Ignorer',
  'recovery.delete': 'Supprimer',
  'recovery.fromAccount': '(copie de votre compte)',
  'recovery.pick': 'Copie à récupérer',

  'bench.title': 'Test de performance',
  'bench.running': 'Mesure en cours… ({n} éléments)',
  'bench.result': '{n} éléments · {fps} img/s · image moyenne {avg} ms · p95 {p95} ms',

  'error.open': "Impossible d'ouvrir le fichier : {msg}",
  'error.save': "Impossible d'enregistrer : {msg}",
  'error.export': "Impossible d'exporter : {msg}",

  'hint.canvas':
    'Glisser : sélectionner · Molette : zoom · Clic milieu, Espace + glisser ou deux doigts : défiler',
  'hint.place': 'Clic : placer · R : pivoter · Échap : terminer',
  'hint.wire':
    'Cliquez une borne pour commencer · Clic : angle · Double-clic : terminer · Retour : annuler un angle · Échap : annuler',

  'tx.move': 'Déplacer',
  'tx.add': 'Ajouter {name}',
  'tx.delete': 'Supprimer',
  'tx.rotate': 'Pivoter',
  'tx.mirror': 'Miroir',
  'tx.wire': 'Tracer un fil',
  'tx.paste': 'Coller',
  'tx.edit': 'Modifier',
  'tx.sheetAdd': 'Ajouter une feuille',
  'tx.sheetDelete': 'Supprimer une feuille',
  'tx.meta': 'Informations du projet',
  'tool.room': 'Pièce',
  'tool.calibrate': "Mettre à l'échelle",
  'panel.circuits': 'Circuits',
  'panel.checks': 'Contrôle {std}',
  'panel.hide': 'Masquer le panneau',
  'panel.background': 'Fond de plan',
  'circ.code': 'Circuit',
  'circ.label': 'Désignation',
  'circ.protection': 'Protection',
  'circ.rcd': 'Différentiel',
  'circ.cableType': 'Câble',
  'circ.section': 'mm²',
  'circ.cores': 'Cond.',
  'circ.length': 'Long. (m)',
  'circ.points': 'Points',
  'circ.legacy': 'Partie anc.',
  'circ.add': 'Ajouter un circuit',
  'circ.renumber': 'Numéroter les circuits',
  'circ.empty':
    'Aucun circuit : ajoutez un disjoncteur sur un schéma unifilaire, importez une photo du tableau ou demandez à l’assistant IA.',
  'circ.mainBus': 'Bus principal',
  'circ.kindSockets': 'Prises',
  'circ.kindLights': 'Éclairage',
  'circ.kindAppliance': 'Appareil',
  'circ.newLabel': 'Nouveau circuit',
  'circ.show': 'Afficher sur le schéma',
  'circ.noSingleLine': "Ajoutez d'abord une feuille « Schéma unifilaire ».",
  'checks.ok': 'Aucun problème détecté par les règles actuelles.',
  'checks.summary': '{e} erreur(s), {w} avertissement(s), {i} info(s)',
  'checks.unverified': 'règle à confirmer',
  'checks.why': 'Pourquoi',
  'checks.fix': 'Correction',
  'checks.askAssistant': 'Corriger avec l’assistant',
  'checks.goProjectInfo': 'Compléter les informations du projet',
  'checks.goMeasurements': 'Saisir les mesures',
  'checks.goCircuits': 'Ouvrir le tableau des circuits',
  'checks.goProperties': 'Modifier ses propriétés',
  'checks.goSheet': 'Réglages de la feuille',
  'checks.goShow': 'Montrer sur le dessin',
  'checks.goNewPlan': 'Créer un plan de position vide',
  'checks.goAddEarth': 'Ajouter la prise de terre',
  'checks.goQuick': 'Corriger',
  'checks.quickMove30': 'Déplacer sous {tag} (30 mA)',
  'checks.quickTypeA': 'Passer {tag} en type A',
  'checks.quickMain300': 'Passer {tag} à 300 mA',
  'checks.quickRating': 'Réduire à {tag}',
  'checks.quickSection': 'Câble {tag} (recâblage)',
  'circ.estimated': 'Estimée depuis le plan : à vérifier sur place',
  'checks.goRenumber': 'Numéroter les circuits',
  'checks.goNumberTerminals': 'Numéroter les bornes',
  'checks.goA3': 'Passer la feuille en A3',
  'checks.goEarthSockets': 'Remplacer par des prises avec terre',
  'checks.goRename': 'Renommer {from} en {tag}',
  'checks.goAttach': 'Raccorder au circuit…',
  'checks.goDrawRoom': 'Dessiner une pièce autour',
  'checks.goDelete': 'Le supprimer',
  'checks.goSpare': 'Marquer comme réserve',
  'checks.goEstimate': 'Estimer depuis le plan',
  'checks.goPhoto': 'Lire sur une photo',
  'checks.estimated': 'Longueurs estimées depuis le plan pour {codes} : à vérifier sur place.',
  'checks.estimateNone':
    'Aucun circuit mesurable sur le plan (il faut le tableau et les points sur un plan importé).',
  'checks.photoRead': 'Lu sur la photo : {what}. À vérifier.',
  'checks.photoNone': 'Rien de lisible sur la photo.',
  'circ.spare': 'Réserve',
  'measure.again': 'Mesurer à nouveau',
  'measure.previous': 'Avant : {what} ({date})',
  'checks.attached': '{tag} raccordé au circuit {code}.',
  'checks.disclaimer': "Aide à la préparation du contrôle — ne remplace pas l'examen par un organisme agréé.",
  'status.checks': '{std} : {e} erreur(s) · {w} avert.',
  'plan.import': 'Importer un plan (image, PDF ou DXF)…',
  'plan.replace': 'Remplacer le plan…',
  'plan.remove': 'Retirer le fond',
  'plan.opacity': 'Opacité',
  'plan.scale': 'Échelle 1:',
  'plan.calibrate': "Mettre à l'échelle…",
  'plan.calibrateHint': 'Cliquez deux points dont vous connaissez la distance réelle (par ex. un mur).',
  'plan.distance': 'Distance réelle entre les deux points (m)',
  'plan.measured': 'Mesuré sur la feuille : {mm} mm',
  'plan.toPlace': 'À placer sur le plan',
  'plan.allPlaced': 'Tous les points du schéma sont placés.',
  'plan.importing': 'Import du plan…',
  'plan.noBackground': 'Aucun fond de plan.',
  'ai.menu': 'IA',
  'ai.board': 'Importer une photo du tableau…',
  'ai.demoBanner':
    "Mode démonstration : l'IA n'est pas encore connectée. Le résultat ci-dessous est un exemple, la photo n'est pas analysée.",
  'ai.demoText': 'Mode démonstration : analyse locale simplifiée (sans IA).',

  // Sign-in prompt for the AI features (signed out).
  'aiGate.title': 'Fonctions IA (bêta) avec un compte Tablo gratuit',
  'aiGate.intro':
    "Les fonctions IA sont gratuites pendant la bêta ; il suffit d'être connecté. Voici ce qu'elles font pour vous :",
  'aiGate.tab.assist': 'Assistant',
  'aiGate.tab.board': 'Photo du tableau',
  'aiGate.tab.sketch': 'Croquis',
  'aiGate.tab.report': 'Rapport de contrôle',
  'aiGate.cap.assist':
    "Demandez une modification en langage courant : l'assistant la prépare, vous l'appliquez en un clic.",
  'aiGate.cap.board':
    'Photographiez un tableau existant : les différentiels et les circuits sont relevés pour vous.',
  'aiGate.cap.sketch': 'Un schéma unifilaire dessiné à la main devient un schéma propre et modifiable.',
  'aiGate.cap.report':
    "Importez le rapport d'un organisme agréé : ses remarques sont reprises, prêtes à suivre.",
  'aiGate.signIn': 'Se connecter ou créer un compte',
  'aiGate.later': 'Plus tard',
  'ai.choosePhoto': 'Choisir une photo…',
  'ai.analyse': 'Analyser',
  'ai.analysing': 'Analyse en cours…',
  'ai.preview': 'Aperçu',
  'ai.previewHint': 'Survolez la proposition pour la voir sur le schéma ; cliquez pour garder l’aperçu.',
  'ai.previewBanner':
    'Aperçu de la proposition, pas encore appliquée : {added} ajout(s), {changed} modification(s), {removed} suppression(s)',
  'ai.rechecking': 'Relecture d’un rail de près…',
  'ai.recheckNote': 'Rail {rail} relu de près : {labels} corrigé(s).',
  'ai.review': "Vérifiez chaque ligne avant d'importer. Les valeurs incertaines sont surlignées.",
  'ai.row': 'Rangée',
  'ai.pos': 'Pos.',
  'ai.type': 'Appareil',
  'ai.rating': 'A',
  'ai.curve': 'Courbe',
  'ai.sens': 'mA',
  'ai.rcdType': 'Type',
  'ai.label': 'Étiquette',
  'ai.confidence': 'Confiance',
  'ai.import': 'Créer le schéma unifilaire',
  'ai.notes': 'Remarques',
  'ai.target': 'Ajouter sous',
  'ai.error': 'Erreur IA : {msg}',
  'ai.unavailable':
    'Les fonctions IA (bêta) sont momentanément indisponibles. Réessayez plus tard : le reste de Tablo fonctionne normalement.',
  'ai.removeRow': 'Supprimer la ligne',
  'ai.addRow': 'Ajouter une ligne',
  'ai.dt.main-switch': 'Interrupteur général',
  'ai.dt.RCD': 'Différentiel',
  'ai.dt.MCB': 'Disjoncteur',
  'ai.dt.RCBO': 'Disj. différentiel',
  'ai.dt.fuse': 'Fusible',
  'ai.dt.contactor': 'Contacteur',
  'ai.dt.timer': 'Minuterie',
  'ai.dt.meter': 'Compteur',
  'ai.dt.other': 'Autre',
  'ai.toFill': 'Points et câbles à compléter : une photo ne les montre pas.',
  'menu.reports': 'Rapports',
  'menu.circuitsCsv': 'Liste des circuits (CSV)',
  'menu.bomCsv': 'Nomenclature (CSV)',
  'menu.labelsPdf': 'Étiquettes du tableau (PDF)',
  'menu.exportPdfFull': 'PDF + liste des circuits',
  'tx.calibrate': "Mettre à l'échelle",
  'tx.background': 'Fond de plan',
  'tx.circuit': 'Modifier le circuit',
  'tx.addCircuit': 'Ajouter un circuit',
  'tx.renumber': 'Numéroter les circuits',
  'tx.aiImport': 'Import IA du tableau',
  'room.default': 'Pièce',
  'hint.room': 'Glissez pour dessiner une pièce · Échap : terminer',
  'hint.calibrate': 'Cliquez le premier point, puis le second · Échap : annuler',
  'menu.diagram': 'Schéma',
  'menu.newFromTemplate': 'Nouveau depuis un modèle…',
  'menu.terminalPlanCsv': 'Plan de bornes (CSV)',
  'cmd.multiLine': 'Générer / mettre à jour le schéma multifilaire',
  'cmd.numberWires': 'Numéroter les fils de cette feuille',
  'cmd.numberTerminals': 'Numéroter les bornes',
  'cmd.insert': 'Insérer',
  'cmd.nothing': 'Rien à changer',
  'cmd.multiLineDone': 'Schéma multifilaire « {name} » à jour',
  'tpl.title': 'Nouveau projet depuis un modèle',
  'tpl.create': 'Créer',
  'ml.generated':
    'Feuille générée depuis « {name} » : les modifications faites à la main seront perdues à la mise à jour.',
  'ml.stale': 'Le schéma unifilaire « {name} » a changé : cette feuille générée n’est plus à jour.',
  'ml.update': 'Mettre à jour',
  'tx.multiLine': 'Schéma multifilaire',
  'tx.numberWires': 'Numéroter les fils',
  'tx.numberTerminals': 'Numéroter les bornes',
  'tx.template': 'Insérer : {name}',
  'tx.assistant': 'Assistant IA',
  'tx.sketch': 'Import d’esquisse',
  'ai.assistant': 'Assistant',
  'ai.sketch': 'Esquisse → schéma…',
  'ai.send': 'Envoyer',
  'ai.askHint': 'Ex. « ajoute une borne de recharge puis génère le multifilaire »',
  'ai.thinking': 'Réflexion…',
  'ai.dictate': 'Dicter',
  'ai.stopDictation': 'Arrêter la dictée ({s} s)',
  'ai.transcribing': 'Transcription…',
  'ai.micDenied': 'Accès au micro refusé : autorisez-le dans les réglages du navigateur ou de l’appareil.',
  'ai.micMissing': 'Aucun micro trouvé.',
  'ai.nothingHeard': 'Rien entendu : parlez plus près du micro.',
  'ai.apply': 'Appliquer',
  'ai.applied': 'Appliqué (annulable avec {mod}Z)',
  'ai.fbUp': 'Réponse utile',
  'ai.fbDown': 'Réponse fausse ou inutile',
  'ai.fbWhat': 'Qu’est-ce qui n’allait pas ? (facultatif)',
  'ai.fbShare':
    'Partager cette conversation et le projet (sans noms, adresses ni photos) pour en faire un cas de test',
  'ai.fbTrain': 'L’utiliser aussi pour entraîner le modèle d’IA de Tablo',
  'ai.fbShareHint':
    'Conservé 12 mois au plus, uniquement par Tablo. Un modèle déjà entraîné avec ne sera pas réentraîné après sa suppression. Voir la politique de confidentialité.',
  'ai.fbShareGood': 'Partager cette réponse comme bon exemple ?',
  'ai.fbSend': 'Envoyer',
  'ai.fbCancel': 'Annuler',
  'ai.fbThanks': 'Merci pour votre retour.',
  'ai.fbError': 'Retour non envoyé : {msg}',
  'ai.skipped': 'Non appliqué : {msg}',
  'ai.proposal': 'Modifications proposées',
  'ai.chooseSketch': 'Choisir une image…',
  'ai.sketchHint': 'Photo ou scan d’un schéma unifilaire dessiné à la main.',
  'ai.sketchResult': '{n} circuit(s) lus, en {g} groupe(s).',
  'ai.mainRcd': 'Différentiel général',
  'circ.method': 'Pose',
  'circ.method.A1': 'A1 · sous conduit dans paroi isolante',
  'circ.method.B1': 'B1 · sous conduit (encastré ou apparent)',
  'circ.method.C': 'C · câble fixé au mur',
  'circ.ib': 'Ib (A)',
  'circ.iz': 'Iz (A)',
  'circ.drop': 'ΔU',
  'circ.lmax': 'L max',
  'circ.ibLoads': 'Calculé à partir des puissances des points',
  'circ.ibRating': 'Puissance inconnue : vérifié au calibre de la protection',
  'circ.dropLimit': 'Limite usuelle : {pct} %',
  'circ.lmaxHint': 'Longueur maximale protégée contre les courts-circuits (méthode conventionnelle)',
  'info.icc': 'Icc présumé à l’origine (kA)',
  'info.iccHint': 'Communiqué par le gestionnaire de réseau ; sert à vérifier le pouvoir de coupure.',
  'menu.exportDxf': 'DXF (feuille courante, pour AutoCAD/QCAD…)',
  'tb.paperRev': 'Format · indice',
  'rev.menu': 'Révisions…',
  'rev.title': 'Révisions',
  'rev.index': 'Ind.',
  'rev.date': 'Date',
  'rev.author': 'Auteur',
  'rev.description': 'Modification',
  'rev.new': 'Nouvelle révision',
  'rev.newHint': 'Fige l’état actuel du projet sous l’indice {index}.',
  'rev.create': 'Créer l’indice {index}',
  'rev.none':
    'Aucune révision. Créez l’indice A quand vous remettez le schéma (au client, à l’organisme de contrôle…).',
  'rev.compare': 'Comparer',
  'rev.restore': 'Revenir à cet état',
  'rev.restoreConfirm': 'Remplacer le projet par l’état de l’indice {index} ? (Annulable.)',
  'rev.diff':
    'Comparaison avec l’indice {index} : {added} ajouté(s), {changed} modifié(s), {removed} supprimé(s)',
  'rev.diffClose': 'Fin de la comparaison',
  'tx.revision': 'Révision {index}',
  'tx.restoreRevision': 'Retour à l’indice {index}',
  'rev.table': 'Révisions',
  'menu.revisionsPdf': 'Tableau des révisions (dans le PDF complet)',
  'cat.user': 'Mes symboles',
  'sym.new': 'Nouveau symbole…',
  'sym.edit': 'Modifier le symbole',
  'sym.newTitle': 'Nouveau symbole',
  'sym.editTitle': 'Modifier le symbole',
  'sym.save': 'Enregistrer le symbole',
  'sym.nameFr': 'Nom (français)',
  'sym.nameEn': 'Nom (anglais)',
  'sym.nameNl': 'Nom (néerlandais)',
  'sym.tagPrefix': 'Lettre de repère',
  'sym.width': 'Largeur (mm)',
  'sym.height': 'Hauteur (mm)',
  'sym.views': 'Disponible dans',
  'sym.hint':
    'Grille de 1,25 mm. Glissez pour tracer ; « Point de connexion » ajoute ou retire un point où se raccordent les fils.',
  'sym.tool.line': 'Ligne',
  'sym.tool.rect': 'Rectangle',
  'sym.tool.circle': 'Cercle',
  'sym.tool.dot': 'Disque',
  'sym.tool.text': 'Texte',
  'sym.tool.port': 'Point de connexion',
  'sym.tool.erase': 'Effacer',
  'sym.problems': 'À compléter : {list}',
  'sym.problem.name': 'nom',
  'sym.problem.empty': 'dessin',
  'sym.problem.views': 'types de schéma',
  'sym.problem.port': 'points en double',
  'sym.problem.port-outside': 'point hors du cadre',
  'tx.newSymbol': 'Nouveau symbole : {name}',
  'tx.editSymbol': 'Symbole modifié : {name}',
  'tx.importSymbols': 'Import de symboles',
  'macro.title': 'Macros',
  'macro.none': 'Sélectionnez un groupe d’éléments puis « Schéma → Enregistrer la sélection comme macro ».',
  'macro.save': 'Enregistrer la sélection comme macro…',
  'macro.name': 'Nom de la macro',
  'macro.saved': 'Macro « {name} » enregistrée',
  'macro.selectFirst': 'Sélectionnez d’abord les éléments à enregistrer',
  'macro.insert': 'Insérer au centre de la vue',
  'macro.delete': 'Supprimer la macro',
  'macro.deleteConfirm': 'Supprimer la macro « {name} » de votre bibliothèque ?',
  'lib.import': 'Importer…',
  'lib.exportSymbols': 'Exporter mes symboles',
  'lib.exportMacros': 'Exporter mes macros',
  'lib.imported': '{n} élément(s) importé(s)',
  'lib.notLibrary': 'Ce fichier n’est pas une bibliothèque Tablo',
  'lib.symbolsFile': 'symboles Tablo',
  'lib.macrosFile': 'macros Tablo',
  'cat.ref': 'Référence fabricant',
  'cat.none': '— aucune —',
  'cat.noMatch': 'Aucune référence du catalogue ne correspond',
  'cat.modules': '{n} module(s)',
  'cat.source': 'source',
  'cat.mismatch': 'ne correspond plus aux caractéristiques',
  'cat.assign': 'Références catalogue',
  'cat.assigned': '{n} référence(s) {brand} attribuée(s) ; {missing} appareil(s) sans équivalent',
  'tx.assignBrand': 'Références {brand}',
  'cmd.boardLayout': 'Générer / mettre à jour l’implantation du tableau',
  'tx.boardLayout': 'Implantation du tableau',
  'legal.privacy': 'Politique de confidentialité',
  'legal.support': 'Support',
  'legal.registerNote': 'Vos données restent en Europe ; détails dans la',
  'about.menu': 'À propos de Tablo…',
  'about.title': 'À propos',
  'about.beta':
    'Version bêta gratuite. Les fonctions peuvent encore changer ; vos fichiers .elec restent lisibles par les versions suivantes. Merci de signaler tout problème.',
  'about.data':
    'Vos projets restent sur votre ordinateur (ou dans votre navigateur) : rien n’est envoyé à un serveur, sauf les photos et textes que vous soumettez à l’IA.',
  'about.aiDemo': 'IA : mode démonstration (aucune donnée envoyée).',
  'about.aiRemote':
    'IA : les photos et descriptions envoyées sont traitées puis supprimées ; elles ne servent pas à entraîner de modèle.',
  'about.rules':
    'Le contrôle RGIE est une aide : il ne remplace ni la lecture du RGIE ni le contrôle par un organisme agréé. Les règles « à confirmer » sont signalées.',
  'about.checkUpdates': 'Rechercher des mises à jour',
  'about.update.unavailable': 'Mises à jour automatiques non disponibles dans cette version.',
  'about.update.up-to-date': 'Tablo est à jour.',
  'about.update.installed': 'Mise à jour installée.',
  'about.update.available': 'Mise à jour disponible.',
  'about.updateAvailable': 'Mise à jour disponible : {v}',
  'about.updateAvailableWord': 'disponible',
  'about.install': 'Installer et redémarrer',
  'welcome.title': 'Bienvenue dans Tablo',
  'welcome.intro':
    'Tablo dessine les schémas d’une installation électrique belge — unifilaire, plan de position, multifilaire, commande, implantation du tableau — et les vérifie selon le RGIE au fur et à mesure.',
  'welcome.s1.title': 'Le tableau',
  'welcome.s1.body':
    'partez d’un modèle, photographiez le tableau (IA), ou ajoutez les circuits dans le panneau « Circuits ».',
  'welcome.s2.title': 'Les points',
  'welcome.s2.body':
    'prises, éclairage et appareils de chaque circuit, avec les longueurs de câble pour les calculs.',
  'welcome.s3.title': 'Le plan de position',
  'welcome.s3.body':
    'importez le plan (PDF, photo ou DXF), mettez-le à l’échelle et placez les points depuis la liste « À placer ».',
  'welcome.s4.title': 'Le contrôle',
  'welcome.s4.body':
    '« Contrôle RGIE » liste ce qui manque ou ne va pas ; cliquez une ligne pour aller à l’endroit.',
  'welcome.s5.title': 'La remise',
  'welcome.s5.body':
    'Schéma → multifilaire et implantation ; Fichier → Révisions, puis Exporter le PDF complet pour le client et l’organisme de contrôle.',
  'welcome.template': 'Partir d’un modèle…',
  'welcome.demo': 'Ouvrir l’exemple',
  'welcome.empty': 'Projet vide',
  'cloud.menu': 'Cloud',
  'cloud.open': 'Comptes et projets en ligne…',
  'cloud.leave': 'Quitter le projet en ligne (garder une copie locale)',
  'cloud.title': 'Tablo en ligne',
  'cloud.intro':
    'Avec un compte, vos projets sont enregistrés en ligne, synchronisés entre vos appareils, et vous pouvez travailler à plusieurs et partager un lien en lecture seule.',
  'cloud.login': 'Se connecter',
  'cloud.register': 'Créer un compte',
  'cloud.name': 'Nom',
  'cloud.email': 'E-mail',
  'cloud.password': 'Mot de passe',
  'cloud.passwordHint': '8 caractères minimum.',
  'cloud.forgot': 'Mot de passe oublié ?',
  'cloud.forgotTitle': 'Mot de passe oublié',
  'cloud.forgotIntro':
    'Indiquez l’adresse de votre compte : vous recevrez un lien pour choisir un nouveau mot de passe.',
  'cloud.forgotSend': 'Envoyer le lien',
  'cloud.forgotSent':
    'Si un compte existe pour {email}, un e-mail vient d’être envoyé. Le lien est valable une heure ; pensez à regarder dans les indésirables.',
  'cloud.backToLogin': 'Retour à la connexion',
  'cloud.registerConfirmNote': 'Nous vous enverrons un lien pour confirmer votre adresse e-mail.',
  'cloud.pendingTitle': 'Confirmez votre adresse e-mail',
  'cloud.pendingBody':
    'Nous avons envoyé un lien à {email}. Ouvrez-le pour activer votre compte : il est valable 48 heures.',
  'cloud.pendingSpam': 'Rien reçu ? Regardez dans les courriers indésirables, ou renvoyez le lien.',
  'cloud.resend': 'Renvoyer le lien',
  'cloud.resent': 'Lien renvoyé. Il remplace le précédent.',
  'cloud.pendingSignIn': 'Déjà confirmé ? Se connecter',
  'cloud.confirmTitle': 'Activation du compte',
  'cloud.confirming': 'Activation en cours…',
  'cloud.confirmExpired':
    'Ce lien a expiré ou a déjà servi. Connectez-vous : si votre adresse n’est pas encore confirmée, vous pourrez recevoir un nouveau lien.',
  'cloud.confirmRetry': 'Réessayer',
  'cloud.confirmed': 'Adresse e-mail confirmée. Bienvenue dans Tablo !',
  'cloud.resetTitle': 'Nouveau mot de passe',
  'cloud.resetIntro':
    'Choisissez le nouveau mot de passe de votre compte. Vos autres appareils seront déconnectés.',
  'cloud.passwordTooShort': 'Mot de passe trop court : 8 caractères minimum.',
  'cloud.newPassword': 'Nouveau mot de passe',
  'cloud.resetSave': 'Enregistrer et se connecter',
  'cloud.resetExpired':
    'Ce lien a expiré ou a déjà servi. Demandez-en un nouveau depuis « Mot de passe oublié ? ».',
  'cloud.signedInAs': 'Connecté :',
  'cloud.logout': 'Se déconnecter',
  'cloud.deleteAccount': 'Supprimer le compte…',
  'cloud.deleteTitle': 'Supprimer votre compte',
  'cloud.deleteIntro':
    'Cette action supprime définitivement le compte {email} et ses données du serveur Tablo :',
  'cloud.deleteWhat':
    'vos projets en ligne de votre espace personnel et des espaces dont vous êtes le seul membre, avec leurs photos, fichiers, historique, liens de partage et modèles, ainsi que vos copies de récupération ;',
  'cloud.deleteShared':
    'dans les espaces partagés avec d’autres, les projets restent à l’équipe ; si vous en étiez le seul propriétaire, un autre membre le devient ;',
  'cloud.deleteLocal':
    'les projets enregistrés sur cet appareil y restent. Pour garder un projet en ligne, ouvrez-le et enregistrez-le d’abord en fichier .tablo.',
  'cloud.deletePassword': 'Votre mot de passe, pour confirmer',
  'cloud.deleteConfirm': 'Supprimer définitivement mon compte',
  'cloud.deleteWrongPassword': 'Mot de passe incorrect.',
  'cloud.deleteOffline': 'Pas de connexion au serveur : le compte ne peut être supprimé qu’en ligne.',
  'cloud.deleted': 'Votre compte et ses données en ligne ont été supprimés.',
  'cloud.workspace': 'Espace',
  'cloud.newWorkspace': 'Nouvel espace d’équipe…',
  'cloud.create': 'Créer',
  'cloud.tab.projects': 'Projets',
  'cloud.tab.members': 'Membres',
  'cloud.tab.templates': 'Modèles de l’équipe',
  'cloud.upload': 'Enregistrer le projet actuel dans « {name} »',
  'cloud.noProjects': 'Aucun projet dans cet espace.',
  'cloud.untitled': 'Sans titre',
  'cloud.personal': 'Espace personnel : créez un espace d’équipe pour travailler à plusieurs.',
  'cloud.role.owner': 'propriétaire',
  'cloud.role.editor': 'éditeur',
  'cloud.role.viewer': 'lecteur',
  'cloud.remove': 'Retirer',
  'cloud.addMember': 'Ajouter',
  'cloud.rolesHint':
    'Éditeurs : modifient les projets. Lecteurs : consultent. Propriétaires : gèrent aussi les membres. La personne doit d’abord créer son compte.',
  'cloud.saveTemplate': 'Enregistrer le projet actuel comme modèle d’équipe',
  'cloud.noTemplates': 'Aucun modèle d’équipe.',
  'cloud.brandTitle': 'Vos schémas,\nsur chaque chantier.',
  'cloud.brand1': 'Enregistrés en ligne et synchronisés entre PC, tablette et téléphone',
  'cloud.brand2': 'Travail à plusieurs dans un espace d’équipe',
  'cloud.brand3': 'Lien en lecture seule pour le client et l’organisme de contrôle',
  'cloud.dataEurope': 'Données hébergées en Europe',
  'cloud.loginTitle': 'Se connecter à Tablo',
  'cloud.registerTitle': 'Créer un compte Tablo',
  'cloud.loginIntro': 'Content de vous revoir. Connectez-vous pour retrouver vos projets en ligne.',
  'cloud.noAccount': 'Pas encore de compte ?',
  'cloud.haveAccount': 'Déjà un compte ?',
  'cloud.showPassword': 'Afficher le mot de passe',
  'cloud.hidePassword': 'Masquer le mot de passe',
  'cloud.workspaces': 'Espaces',
  'cloud.searchProjects': 'Rechercher un projet',
  'cloud.uploadHere': 'Enregistrer le projet actuel ici',
  'cloud.col.project': 'Projet',
  'cloud.col.updated': 'Modifié',
  'cloud.col.by': 'Par',
  'cloud.col.template': 'Modèle',
  'cloud.openNow': 'ouvert',
  'cloud.noMatch': 'Aucun projet ne correspond à « {q} ».',
  'cloud.you': 'vous',
  'cloud.liveIn': 'Projet ouvert en ligne dans « {name} »',
  'cloud.liveOffline': 'Hors ligne : les modifications partiront au retour de la connexion',
  'cloud.menuProjects': 'Projets en ligne…',
  'cloud.menuMembers': 'Membres…',
  'cloud.menuTemplates': 'Modèles de l’équipe…',
  'cloud.accountMenu': 'Compte',
  'cloud.emailPlaceholder': 'nom@entreprise.be',
  'cloud.roleOf': 'Rôle de',
  'cloud.memberEmail': 'E-mail du nouveau membre',
  'cloud.synced': '☁ Synchronisé',
  'cloud.syncing': '☁ Envoi… ({n})',
  'cloud.offline': '☁ Hors ligne · {n} modification(s) en attente',
  'cloud.with': 'avec {names}',
  'cloud.readOnly': 'lecture seule',
  'cloud.rejected': 'Modification « {label} » annulée : un autre utilisateur a changé ces éléments.',
  'cloud.error': 'Erreur du serveur : {msg}',
  'cloud.uploaded': 'Projet enregistré dans « {name} » ; les modifications sont synchronisées.',
  'cloud.teamLibrary': 'Bibliothèque de l’équipe',
  'cloud.shareToTeam': 'Partager mes symboles et macros avec l’équipe',
  'cloud.sharedToTeam': 'Symboles et macros partagés avec « {name} »',
  'share.menu': 'Partager…',
  'share.title': 'Partager en lecture seule',
  'share.intro':
    'Un lien permet au client, à l’architecte ou à l’organisme de contrôle de consulter et télécharger les schémas, sans compte et sans pouvoir les modifier.',
  'share.live': 'Toujours la dernière version',
  'share.atRevision': 'Figé à l’indice {index}',
  'share.create': 'Créer le lien',
  'share.none': 'Aucun lien pour ce projet.',
  'share.copy': 'Copier',
  'share.handover': 'Dossier de remise (PDF + QR code)',
  'share.revoke': 'Désactiver',
  'viewer.status': 'Lecture seule (lien partagé)',
  'viewer.live': 'Schémas partagés — lecture seule',
  'viewer.revision': 'Schémas à l’indice {index} — lecture seule',
  'viewer.download': 'Télécharger le PDF',
  'viewer.error': 'Lien de partage invalide : {msg}',

  'dxf.title': 'Importer un plan DXF',
  'dxf.info': 'Fichier DXF {version} · {w} × {h} m',
  'dxf.units': 'Unité du dessin',
  'dxf.unitsStated': 'indiquée dans le fichier',
  'dxf.unitsGuessed': 'estimée d’après la taille : à vérifier',
  'dxf.scale': 'Échelle',
  'dxf.paperSize': 'Sur la feuille : {w} × {h} mm',
  'dxf.tooBig': 'Plus grand que la zone de dessin : choisissez une échelle plus petite ou une feuille A3.',
  'dxf.layers': 'Calques',
  'dxf.layerCount': '{n} élément(s)',
  'dxf.hiddenLayer': 'masqué dans le fichier',
  'dxf.all': 'Tout',
  'dxf.none': 'Aucun',
  'dxf.import': 'Importer',
  'dxf.strays': '{n} élément(s) isolé(s), loin du dessin, ignoré(s).',
  'dxf.skipped': 'Non repris : {list}.',
  'dxf.dwg':
    'Fichier DWG (AutoCAD {version}) : ce format fermé ne se lit pas directement. Enregistrez-le en DXF depuis votre logiciel de DAO (Enregistrer sous → DXF) ou convertissez-le avec ODA File Converter (gratuit), puis importez le DXF.',
  'dxf.binary': 'DXF binaire non pris en charge : réenregistrez-le en DXF ASCII (texte).',
  'dxf.notDxf': 'Ce fichier n’est pas un DXF lisible.',
  'dxf.empty': 'Aucun élément à importer sur les calques choisis.',
  'dxf.trueScale': 'Le plan est à l’échelle réelle : pas besoin d’étalonner.',

  'quote.menu': 'Devis et nomenclature (Excel)…',
  'quote.title': 'Devis et nomenclature',
  'quote.intro':
    'Matériel des schémas unifilaires, câbles d’après les longueurs des circuits et une ligne de main-d’œuvre. Les prix viennent de votre liste de prix (grossiste) ; tout reste modifiable dans le fichier.',
  'quote.priceList': 'Liste de prix',
  'quote.importPrices': 'Importer une liste de prix (CSV, Excel)…',
  'quote.priceListInfo': '{name} · {n} prix',
  'quote.noPriceList': 'Aucune liste de prix : les prix restent à compléter dans le fichier.',
  'quote.removePrices': 'Retirer',
  'quote.noPrices': 'Aucun prix trouvé : la liste doit avoir une colonne référence et une colonne prix.',
  'quote.vat': 'TVA',
  'quote.vat6': '6 % (rénovation d’un logement de plus de 10 ans)',
  'quote.vat21': '21 %',
  'quote.waste': 'Chutes de câble (%)',
  'quote.discount': 'Remise sur le matériel (%)',
  'quote.missingLengths': 'Câble non compté pour {n} circuit(s) sans longueur : {list}.',
  'quote.lines': '{n} ligne(s), dont {priced} avec un prix',
  'quote.totals': 'Total HTVA {sub} · TVA {vat} · TVAC {total}',
  'quote.xlsx': 'Excel (.xlsx)',
  'quote.csv': 'CSV',
  'quote.fromSurvey':
    'Le relevé n’a pas encore donné de schémas : générez-les pour que le devis reprenne son matériel.',
  'quote.file': 'devis',
  'quote.colRef': 'Réf.',
  'quote.colDesc': 'Désignation',
  'quote.colQty': 'Qté',
  'quote.colPrice': 'PU HTVA',
  'quote.colSource': 'Source',
  'quote.sourceStale': '{name} : la dernière mise à jour a échoué ; les prix du {date} sont utilisés.',
  'quote.serverPricesDown':
    'Les prix des grossistes n’ont pas pu être chargés (pas de connexion) : devis chiffré avec les autres sources.',
  'quote.sourceReference': 'Prix de référence Tablo (Belgique)',
  'quote.sourceUpdated': 'mise à jour le {date}',
  'quote.sourceOrder': 'Ordre utilisé quand un prix manque : {list}',
  'quote.preferredSource': 'Source de prix préférée',
  'quote.downloadPrices': 'Télécharger les prix (Excel)…',
  'quote.priceListFile': 'Prix Tablo.xlsx',
  'quote.useLibrary': 'Compléter les prix manquants avec les prix de référence belges (vérifiés le {date})',
  'quote.libraryPrice':
    'Les prix de référence Tablo sont des prix publics HTVA : ceux de votre grossiste sont plus bas.',
  'quote.labourHours': 'Main-d’œuvre (heures)',

  'survey.mode': 'Relevé sur site',
  'survey.menu': 'Relevé sur site (téléphone, tablette)',
  'survey.homeTitle': 'Relevés',
  'survey.intro':
    'Relevez l’installation pièce par pièce, photographiez le tableau : Tablo en tire le schéma unifilaire et les plans de position. Fonctionne sans réseau.',
  'survey.new': 'Nouveau relevé',
  'survey.newTitle': 'Relevé du {date}',
  'survey.current': 'Projet ouvert',
  'survey.continue': 'Continuer',
  'survey.onDevice': 'Sur cet appareil',
  'survey.cloudTeam': 'Cloud — {team}',
  'survey.noProjects': 'Aucun projet sur cet appareil.',
  'survey.offlineCopy': 'copie hors ligne',
  'survey.cloudBadge': 'Cloud',
  'survey.remove': 'Retirer de l’appareil',
  'survey.removeConfirm': 'Retirer « {name} » de cet appareil ? Un projet cloud reste sur le serveur.',
  'survey.signIn': 'Se connecter au cloud',
  'survey.install': 'Installer l’application',
  'survey.installIos': 'Pour l’installer : bouton Partager, puis « Sur l’écran d’accueil ».',
  'survey.storageWarn':
    'Installez l’application : sinon le navigateur peut effacer les relevés gardés sur l’appareil.',
  'survey.openEditor': 'Ouvrir dans l’éditeur',
  'survey.back': 'Retour',
  'survey.tabRooms': 'Pièces',
  'survey.tabBoard': 'Tableau',
  'survey.tabChecks': 'Contrôle',
  'survey.tabInfo': 'Projet',
  'survey.addRoom': 'Ajouter une pièce',
  'survey.roomName': 'Nom de la pièce',
  'survey.roomType': 'Type de pièce',
  'survey.level': 'Étage',
  'survey.noRooms': 'Commencez par la pièce où vous êtes.',
  'survey.points': 'Points',
  'survey.morePoints': 'Autres points…',
  'survey.noPoints': 'Aucun point dans cette pièce : ajoutez-les ci-dessous.',
  'survey.circuit': 'Circuit',
  'survey.noCircuit': 'Sans circuit',
  'survey.chooseCircuit': 'Circuit de ces points',
  'survey.newCircuit': 'Nouveau circuit',
  'survey.notes': 'Notes',
  'survey.photos': 'Photos',
  'survey.takePhoto': 'Photo',
  'survey.fromGallery': 'Galerie',
  'survey.removePhoto': 'Supprimer la photo',
  'survey.deleteRoom': 'Supprimer la pièce',
  'survey.deleteRoomConfirm': 'Supprimer « {name} » et ses points ?',
  'survey.pointCount': '{n} point(s)',
  'survey.unassigned': '{n} sans circuit',
  'survey.addBoard': 'Ajouter un tableau',
  'survey.mainBoard': 'Tableau principal',
  'survey.boardName': 'Nom du tableau',
  'survey.boardPhotos': 'Photos du tableau',
  'survey.readBoard': 'Lire le tableau (IA)',
  'survey.reading': 'Lecture de la photo…',
  'survey.readResult': '{circuits} circuit(s) et {rcds} différentiel(s) reconnus.',
  'survey.readApply': 'Remplir le tableau',
  'survey.readKeeps': 'Les circuits déjà relevés sont mis à jour dans l’ordre et gardent leurs points.',
  'survey.readError': 'Lecture impossible : {msg}',
  'survey.mainSwitch': 'Interrupteur général',
  'survey.mainRcd': 'Différentiel général',
  'survey.none': 'Aucun',
  'survey.rcds': 'Différentiels',
  'survey.addRcd': 'Ajouter un différentiel',
  'survey.rcdLabel': 'Différentiel {ma} mA',
  'survey.mainBus': 'Directement sous le général',
  'survey.circuits': 'Circuits',
  'survey.addCircuit': 'Ajouter un circuit',
  'survey.circuitLabel': 'Description',
  'survey.circuitLabelPh': 'p. ex. Prises cuisine',
  'survey.device': 'Protection',
  'survey.devMCB': 'Disjoncteur',
  'survey.devRCBO': 'Disj. différentiel',
  'survey.devFuse': 'Fusible',
  'survey.rating': 'Calibre (A)',
  'survey.curve': 'Courbe',
  'survey.poles': 'Pôles',
  'survey.section': 'Section (mm²)',
  'survey.cableType': 'Câble',
  'survey.cores': 'Conducteurs',
  'survey.length': 'Longueur (m)',
  'survey.rcdOf': 'Différentiel',
  'survey.legacy': 'Partie ancienne (avant le 1er octobre 1981)',
  'survey.circuitPoints': 'Points alimentés',
  'survey.deleteCircuit': 'Supprimer le circuit',
  'survey.deleteCircuitConfirm': 'Supprimer le circuit {code} ? Ses points restent, sans circuit.',
  'survey.deleteBoard': 'Supprimer le tableau',
  'survey.deleteBoardConfirm': 'Supprimer « {name} » et ses circuits ?',
  'survey.deleteRcd': 'Supprimer le différentiel',
  'survey.earth': 'Prise de terre',
  'survey.earthOhm': 'Résistance mesurée (Ω)',
  'survey.sensitivity': 'Sensibilité (mA)',
  'survey.rcdType': 'Type',
  'survey.checksOk': 'Rien à signaler.',
  'survey.fromDiagram': 'Règle {std}, sur les schémas qui seront générés',
  'survey.generate': 'Générer les schémas',
  'survey.regenerate': 'Mettre à jour les schémas',
  'survey.generated': '{n} feuille(s) générée(s) depuis le relevé.',
  'survey.stale': 'Le relevé a changé depuis la génération des schémas.',
  'survey.upToDate': 'Les schémas suivent le relevé.',
  'survey.notGenerated':
    'Pas encore de schémas : générez-les quand le relevé est complet (ou dès maintenant, pour voir).',
  'survey.regenerateWarn':
    'Les feuilles générées depuis le relevé sont remplacées : ce qui y a été modifié à la main est perdu.',
  'survey.statusSaved': 'Enregistré',
  'survey.statusSynced': 'Synchronisé',
  'survey.statusPending': 'À envoyer : {n}',
  'survey.statusOffline': 'Hors ligne',
  'survey.statusFiles': 'Photos à envoyer : {n}',
  'survey.statusFile': 'Fichier {name}',
  'survey.keepOnDevice': 'Garder sur l’appareil',
  'survey.kept': 'Projet gardé sur cet appareil.',
  'survey.pdf': 'PDF des schémas',
  'survey.quantity': 'Quantité',
  'survey.deletePoint': 'Supprimer',
  'survey.upload': 'Mettre dans le cloud ({team})',
  'survey.cloudSection': 'Cloud',
  'survey.inCloud': 'Dans le cloud — {team}',
  'survey.done': 'OK',

  // ---------- after the drawing: measurements, inspection reports, invoices ----------
  'menu.inspection': 'Contrôle',
  'panel.photos': 'Photos',
  'quote.invoice': 'Facturer…',
  'survey.measure': 'Saisir les mesures',
  'survey.pointPhotos': 'Photos du point ({n})',
  'measure.menu': 'Mesures et essais…',
  'measure.earth': 'Prise de terre',
  'measure.earthOhm': 'Résistance de dispersion (Ω)',
  'measure.title': 'Mesures et essais',
  'measure.intro':
    'Une fiche par circuit et par différentiel du schéma. Chaque valeur est comparée à sa limite dès qu’elle est saisie ; les règles R-TEST signalent ce qui échoue ou manque.',
  'measure.date': 'Date des essais',
  'measure.circuits': 'Circuits',
  'measure.rcds': 'Différentiels',
  'measure.insulation': 'Isolement (MΩ)',
  'measure.testVoltage': 'Tension d’essai',
  'measure.continuity': 'Continuité PE (Ω)',
  'measure.loop': 'Boucle de défaut Zs (Ω)',
  'measure.noLimit': 'fusible : pas de limite',
  'measure.tripMs': 'Temps de déclenchement (ms)',
  'measure.tripMa': 'Courant de déclenchement (mA)',
  'measure.testButton': 'Bouton test',
  'measure.trips': 'Déclenche',
  'measure.noTrip': 'Ne déclenche pas',
  'measure.nothing':
    'Aucun circuit ni différentiel au schéma : dessinez ou générez le schéma unifilaire d’abord.',
  'measure.progress': '{m}/{c} circuits mesurés · {r}/{n} différentiels essayés · {f} non conforme(s)',
  'measure.csv': 'Exporter (CSV)',
  'measure.file': 'mesures',
  'measure.tx': 'Mesure {ref}',
  'inspection.menu': 'Procès-verbaux et remarques…',
  'inspection.title': 'Procès-verbaux de contrôle',
  'inspection.read': 'Lire un procès-verbal (photo ou PDF)…',
  'inspection.reading': 'Lecture du procès-verbal…',
  'inspection.readFailed': 'Lecture impossible : {error}',
  'inspection.manual': 'Saisir à la main',
  'inspection.none':
    'Aucun procès-verbal pour ce projet. Lisez celui de l’organisme agréé, ou saisissez ses remarques à la main.',
  'inspection.pick': 'Procès-verbal',
  'inspection.body': 'Organisme agréé',
  'inspection.reference': 'N° du procès-verbal',
  'inspection.date': 'Date de la visite',
  'inspection.inspector': 'Agent visiteur',
  'inspection.result': 'Résultat',
  'inspection.conform': 'Conforme',
  'inspection.notConform': 'Non conforme',
  'inspection.deadline': 'Délai pour les travaux',
  'inspection.pages': 'Pages du procès-verbal',
  'inspection.remarksFound': '{n} remarque(s) lue(s) — décochez celles à ne pas reprendre',
  'inspection.addToProject': 'Ajouter au projet ({n})',
  'inspection.txAdd': 'Procès-verbal de contrôle',
  'inspection.remarks': 'Remarques — {open} à lever sur {n}',
  'inspection.remarksTitle': 'Remarques du contrôle',
  'inspection.openCount': '{n} à lever sur {total}',
  'inspection.pack': 'Dossier de recontrôle (PDF)',
  'inspection.packFile': 'dossier de recontrôle',
  'inspection.delete': 'Supprimer le procès-verbal',
  'inspection.deleteConfirm': 'Le procès-verbal et ses {n} remarque(s) seront supprimés du projet.',
  'remark.one': 'remarque',
  'remark.add': 'Ajouter une remarque',
  'remark.open': 'À lever',
  'remark.fixed': 'Levée',
  'remark.text': 'Remarque',
  'remark.article': 'Article',
  'remark.ref': 'Circuit ou point',
  'remark.fixNote': 'Ce qui a été fait',
  'remark.fixNoteHint': 'Ex. : différentiel 30 mA type A ajouté sur le circuit B',
  'remark.photos': 'Photos de la correction',
  'remark.delete': 'Supprimer la remarque',
  'invoice.menu': 'Factures…',
  'invoice.title': 'Factures',
  'invoice.intro':
    'Les factures émises restent dans le projet et ne sont plus modifiées. Chacune se télécharge en PDF (avec un code QR de virement) et, entre entreprises, au format Peppol (UBL) pour la facturation électronique obligatoire en Belgique depuis 2026.',
  'invoice.none': 'Aucune facture pour ce projet.',
  'invoice.new': 'Nouvelle facture',
  'invoice.creditNote': 'Note de crédit…',
  'invoice.newCreditNote': 'Nouvelle note de crédit',
  'invoice.kindCredit': 'note de crédit',
  'invoice.creditFor':
    'Note de crédit pour la facture {n} du {date} : retirez les lignes ou réduisez les quantités qui ne sont pas créditées.',
  'invoice.creditHint': 'Corriger ou annuler cette facture (tout ou partie de ses lignes)',
  'invoice.kindDeposit': 'acompte',
  'invoice.depositPct': 'Acompte (%)',
  'invoice.makeDeposit': 'Faire une facture d’acompte',
  'invoice.depositHint':
    'Remplace les lignes par une seule : cette part de leur total, à leur taux de TVA. La facture finale la déduit.',
  'invoice.depositLine': 'Acompte {pct} % — {ref}',
  'invoice.depositDeducted': 'Acompte facturé (facture {n} du {date})',
  'invoice.deductDeposits': 'Déduire les factures d’acompte ({n})',
  'invoice.isDeposit': 'Facture d’acompte : la facture finale la déduira.',
  'invoice.vatPart': 'TVA {pct} % sur {base} : {vat}',
  'invoice.seriesTeam':
    'Numéro donné par l’espace « {team} » à l’émission : une seule série pour toute l’entreprise.',
  'invoice.seriesOffline': 'Le numéro vient de l’espace « {team} » : connectez-vous pour émettre.',
  'invoice.seriesStart':
    'Nouvelle série de factures {prefix} pour « {team} ». Vous poursuivez une numérotation existante ? Prochain numéro :',
  'invoice.seriesStartLabel': 'Prochain numéro de la série',
  'invoice.seriesSet': 'Valider',
  'invoice.emailAction': 'E-mail…',
  'invoice.emailTitle': 'Envoyer {n} au client',
  'invoice.emailTo': 'À',
  'invoice.emailMessage': 'Votre message (facultatif)',
  'invoice.emailXml': 'Joindre le fichier Peppol (client entreprise)',
  'invoice.emailReply':
    'Envoyé depuis l’adresse de Tablo à votre nom ; les réponses du client arrivent à {email}.',
  'invoice.emailAccount': 'l’adresse de votre compte',
  'invoice.emailSend': 'Envoyer',
  'invoice.emailSent': '{n} envoyée à {to}.',
  'invoice.emailFailed': 'Non envoyé : {msg}',
  'billit.pitch': 'Envoyez vos factures par Peppol et suivez leur paiement avec Billit :',
  'billit.connect': 'Se connecter à Billit',
  'billit.waiting': 'En attente de Billit…',
  'billit.connectedTo': 'Connecté à Billit : transmettez vos factures depuis la liste.',
  'billit.disconnect': 'Déconnecter',
  'billit.title': 'Transmettre {n} à Billit',
  'billit.explain':
    'La facture arrive telle quelle dans votre compte Billit (même numéro, mêmes lignes, même PDF). Billit l’envoie, suit son paiement et la transmet à votre comptable.',
  'billit.peppolNow': 'L’envoyer par Peppol maintenant',
  'billit.noPeppol':
    'Pas par Peppol (client particulier, ou identifiants Peppol manquants) : Billit la garde pour que vous l’envoyiez',
  'billit.send': 'Envoyer à Billit',
  'billit.sent': '{n} est dans Billit.',
  'billit.sentPeppol': '{n} est dans Billit et part par Peppol.',
  'billit.failed': 'Billit : {msg}',
  'billit.tx': 'Transmettre la facture {n} à Billit',
  'billit.statusHint': 'Lire son état chez Billit',
  'billit.paid': 'payée',
  'billit.status.ToSend': 'à envoyer',
  'billit.status.ToPay': 'envoyée, à payer',
  'billit.status.Paid': 'payée',
  'billit.connectedNotice': 'Connecté à Billit.',
  'billit.failedNotice': 'Billit n’a pas été connecté : réessayez depuis les factures.',
  'invoice.problem.negativeTotal': 'Le total est négatif : faites plutôt une note de crédit.',
  'invoice.problem.negativePrice':
    'Un prix unitaire est négatif : déduisez un montant avec une quantité négative.',
  'invoice.issue': 'Émettre la facture',
  'invoice.txIssue': 'Facture {n}',
  'invoice.duplicate': 'Le numéro {n} est déjà utilisé dans ce projet.',
  'invoice.file': 'Facture',
  'invoice.seller': 'Vos coordonnées',
  'invoice.sellerKept': '(gardées sur cet appareil)',
  'invoice.buyer': 'Client',
  'invoice.buyerHint':
    'Particulier : laissez le n° de TVA vide, la facture se remet en PDF. Entreprise : son n° d’entreprise sert d’identifiant Peppol (0208).',
  'invoice.details': 'Facture',
  'invoice.name': 'Nom ou raison sociale',
  'invoice.vatNumber': 'N° de TVA',
  'invoice.street': 'Rue et numéro',
  'invoice.postcode': 'Code postal',
  'invoice.city': 'Localité',
  'invoice.country': 'Pays',
  'invoice.email': 'E-mail',
  'invoice.peppolId': 'Identifiant Peppol (facultatif)',
  'invoice.number': 'N°',
  'invoice.vat': 'TVA',
  'invoice.reverseCharge': 'Autoliquidation (cocontractant)',
  'invoice.issueDate': 'Date',
  'invoice.dueDate': 'Échéance',
  'invoice.orderRef': 'Référence du client (bon de commande, devis)',
  'invoice.paymentRef': 'Communication structurée',
  'invoice.note': 'Mention',
  'invoice.lines': 'Lignes',
  'invoice.addQuoteLines': 'Reprendre le devis',
  'invoice.addLine': 'Ligne',
  'invoice.unit': 'Unité',
  'invoice.unit.C62': 'pièce',
  'invoice.unit.MTR': 'mètre',
  'invoice.unit.HUR': 'heure',
  'invoice.amount': 'Montant',
  'invoice.total': 'Total TVAC',
  'invoice.peppolReady':
    '✓ Prête pour Peppol : le fichier UBL peut être envoyé par votre point d’accès Peppol ou le portail Hermes.',
  'invoice.pdfOnly': 'Facture en PDF (client sans n° d’entreprise belge : pas d’envoi Peppol).',
  'invoice.peppolHint': 'Fichier Peppol BIS Billing 3.0 (UBL) à envoyer par votre point d’accès',
  'invoice.peppolMissing': 'Le client n’a pas d’identifiant Peppol (n° d’entreprise belge)',
  'invoice.problem.sellerName': 'Votre nom ou raison sociale manque.',
  'invoice.problem.sellerVat': 'Votre n° de TVA manque ou n’est pas valable.',
  'invoice.problem.sellerAddress': 'Votre adresse est incomplète.',
  'invoice.problem.sellerIban': 'L’IBAN n’est pas valable.',
  'invoice.problem.buyerName': 'Le nom du client manque.',
  'invoice.problem.buyerAddress': 'L’adresse du client manque.',
  'invoice.problem.buyerVatReverse': 'L’autoliquidation demande le n° de TVA du client.',
  'invoice.problem.buyerVat': 'Le n° de TVA du client n’est pas valable.',
  'invoice.problem.noLines': 'La facture n’a aucune ligne.',
  'invoice.problem.lineDescription': 'Une ligne n’a pas de désignation.',
  'invoice.problem.number': 'Le numéro de facture manque.',
  'invoice.problem.dates': 'Les dates ne sont pas valables (échéance avant la date de facture ?).',
  'invoice.problem.paymentRef': 'La communication structurée n’est pas valable.',

  // Tutoriel guidé (Tour.tsx, tourSteps.ts)
  'tour.menu': 'Tutoriel guidé',
  'tour.welcome': 'Suivre le tutoriel guidé',
  'tour.begin': 'Commencer',
  'tour.next': 'Suivant',
  'tour.back': 'Retour',
  'tour.replay': 'Revoir',
  'tour.skipDemo': 'Passer la démo',
  'tour.restart': 'Recommencer',
  'tour.finish': 'Terminer',
  'tour.close': 'Fermer le tutoriel',
  'tour.playPart': 'Revoir cette partie',
  'tour.prevPart': 'Partie précédente',
  'tour.nextPart': 'Partie suivante',
  'tour.cap.aiBoard': 'Lire un tableau sur photo',
  'tour.cap.ib': 'Courant d’emploi du circuit d’éclairage',
  'tour.sample.circuit': 'Cuisine',
  'side.label': 'Barre latérale',
  'side.fold': 'Replier la barre latérale',
  'side.unfold': 'Déplier la barre latérale',
  'palette.fold': 'Replier le panneau des symboles',
  'palette.unfold': 'Déplier le panneau des symboles',
  'side.assistant': 'Assistant IA',
  'side.selectHint':
    'Cliquez sur un symbole ou un fil de la feuille pour voir et modifier ses propriétés ici.',
  'side.assistHint':
    'Demandez une modification avec vos mots, par exemple « ajoute une borne de recharge en 32 A puis génère le multifilaire ». Vous voyez ce qui changera avant de l’appliquer.',
  'side.assistSignedOut':
    'L’assistant modifie le schéma à partir d’une demande formulée avec vos mots. Connectez-vous pour l’utiliser.',
  'tour.area.assistant': 'L’assistant IA',
  'tour.area.rail': 'Une icône par section',
  'tour.cap.assistant': 'Ouvert par IA → Assistant',
  'tour.cap.assistSend': 'Envoyer, puis vérifier la proposition',
  'tour.cap.assistSignIn': 'L’assistant demande un compte',
  'tour.sample.assist': 'Ajoute une borne de recharge en 32 A puis génère le multifilaire',
  'tour.tipLabel': 'Bonne pratique',
  'tour.chapter': 'Partie {n}/{total}',
  'tour.ch1': 'Démarrer un projet',
  'tour.ch2': 'Dessiner à la main',
  'tour.ch3': 'Le tableau des circuits',
  'tour.ch4': 'Le contrôle',
  'tour.ch5': 'Les autres schémas',
  'tour.ch6': 'Enregistrer et remettre',
  'tour.sample.title': 'Maison Dupont',
  'tour.sample.owner': 'Marie Dupont',
  'tour.sample.address': 'Rue de la Station 12, 1300 Wavre',
  'tour.area.toolbar': 'Menus et outils',
  'tour.area.palette': 'Symboles',
  'tour.area.canvas': 'La feuille',
  'tour.area.inspector': 'Barre latérale : sélection, assistant IA, feuille',
  'tour.area.sheets': 'Feuilles',
  'tour.area.status': 'État et compteur du contrôle',
  'tour.cap.template': 'Maison, appartement ou atelier tout prêts',
  'tour.cap.survey': 'À partir de votre relevé sur site',
  'tour.cap.example': 'Une maison complète à explorer',
  'tour.cap.standard': 'Les règles appliquées par le contrôle',
  'tour.cap.locale': 'La langue des schémas',
  'tour.cap.icc': 'Nécessaire pour vérifier les pouvoirs de coupure',
  'tour.cap.titleBlock': 'Le cartouche se remplit tout seul',
  'tour.cap.search': 'Trouver un symbole par son nom',
  'tour.cap.tag': 'Repéré W1 automatiquement',
  'tour.cap.label': 'L’étiquette suit les propriétés',
  'tour.cap.drop': 'Chute de tension comparée à sa limite',
  'tour.cap.codes': 'Codes des circuits dans l’ordre',
  'tour.cap.statusChecks': 'Toujours visible',
  'tour.cap.banner': 'Généré depuis le schéma unifilaire',
  'tour.cap.sheetKinds': 'Types de feuille',
  'tour.cap.revisions': 'Figer la révision A, B…',
  'tour.cap.exportFull': 'Le PDF complet pour la remise',
  'tour.cap.quote': 'Devis et nomenclature',
  'tour.cap.cloud': 'Synchronisation, équipe et partage',

  'tour.intro.title': 'Dessinez votre première installation',
  'tour.intro.body':
    'En une dizaine de minutes, vous allez démarrer un projet et dessiner un petit schéma unifilaire, puis laisser Tablo faire le reste : circuits, calculs, contrôle RGIE et schéma multifilaire.\nChaque étape **met en évidence** une partie de l’écran et la montre, une partie à la fois : les flèches **‹ ›** — ou les touches **← →** — jouent la partie précédente ou suivante. À la fin d’une étape, tous les paragraphes sont listés avec la bonne pratique ; cliquez sur l’un d’eux pour le revoir. Essayez vous-même entre les parties, puis cliquez sur **Suivant**.\nLe tutoriel travaille dans un nouveau projet vide : gardez-le ou jetez-le à la fin.',
  'tour.intro.tip':
    'Tablo est fait pour un ordinateur avec souris et clavier. Sur un téléphone, il ouvre plutôt le **relevé sur site** : notez les pièces et les points sur le chantier, puis terminez les schémas ici.',

  'tour.workspace.title': 'Votre espace de travail',
  'tour.workspace.p1':
    '**Barre du haut** : les menus (Fichier, Schéma, Contrôle, IA), annuler, les outils et les panneaux Circuits et Contrôle RGIE.',
  'tour.workspace.p2': '**Symboles** à gauche : les symboles du type de feuille en cours.',
  'tour.workspace.p3':
    '**La feuille** au centre, un vrai cadre de plan avec son cartouche. Molette ou pincement pour zoomer, bouton du milieu ou Espace + glisser pour se déplacer, **F** pour tout voir.',
  'tour.workspace.p4':
    'La **barre latérale** à droite est faite de sections qui se déplient et se replient : **Sélection** (les propriétés de ce qui est sélectionné), l’**assistant IA** et **Feuille** (nom, type, format, informations du projet).',
  'tour.workspace.p5':
    'Le bouton en haut replie la barre en une colonne d’icônes, pour laisser plus de place à la feuille. Cliquez sur une icône pour afficher sa section ; cliquez à nouveau, ou sur la feuille, pour la ranger.',
  'tour.workspace.p6': '**Feuilles** en bas, puis la **barre d’état** avec le compteur du contrôle.',
  'tour.workspace.tip':
    'Apprenez tôt les outils à une touche — **V** sélection, **W** fil, **T** texte, **R** rotation, **F** tout voir. Main gauche sur le clavier, main droite sur la souris : c’est la façon la plus rapide de dessiner.',

  'tour.start.title': 'Trois façons de commencer',
  'tour.start.p1':
    '**Fichier → Nouveau depuis un modèle** : une maison, un appartement ou un atelier triphasé, tableau déjà dessiné.',
  'tour.start.p2':
    '**Fichier → Relevé sur site** : ce que vous avez noté sur le téléphone devient les schémas.',
  'tour.start.p3': '**Fichier → Exemple** : une maison complète pour faire le tour.',
  'tour.start.p4': '**IA → Importer une photo du tableau** lit un tableau existant, appareil par appareil.',
  'tour.start.tip':
    'Pour un vrai chantier, ne partez pas d’une feuille vide : partez d’un modèle ou de votre relevé, puis adaptez. Le tableau est organisé selon le RGIE dès la première minute.',

  'tour.info.title': 'D’abord les informations du projet',
  'tour.info.p1':
    '**Fichier → Informations du projet** remplit le cartouche de chaque feuille : projet, propriétaire, adresse de l’installation, auteur.',
  'tour.info.p2':
    'La **norme** décide des règles appliquées par le contrôle : RGIE, NF C 15-100 ou NEN 1010.',
  'tour.info.p3':
    'La **langue des schémas** peut différer de celle de l’interface : une interface en français pour un client flamand, par exemple.',
  'tour.info.p4':
    'Le schéma des liaisons à la terre, la tension et le **courant de court-circuit présumé** à l’origine.',
  'tour.info.p5': '**OK** : le cartouche de chaque feuille se remplit tout seul.',
  'tour.info.tip':
    'Remplissez-les avant de dessiner. Indiquez l’Icc à l’origine, sinon les pouvoirs de coupure ne peuvent pas être vérifiés, et dessinez dans la langue du client : c’est ce que le client et l’organisme agréé liront.',

  'tour.palette.title': 'La palette de symboles',
  'tour.palette.p1':
    'Les symboles sont rangés par famille (distribution, protection, prises, éclairage…) et filtrés selon le type de feuille. Tapez dans la recherche pour en trouver un par son nom.',
  'tour.palette.p2':
    'Cliquez sur un symbole, puis sur la feuille — ici, l’**alimentation**. Elle reçoit tout de suite son repère, W1.',
  'tour.palette.tip':
    'La palette ne propose que ce qui a sa place sur ce type de feuille. Ne cochez **Tous les symboles** que si vous en avez vraiment besoin, et créez ce qui manque avec **Nouveau symbole…** en bas plutôt que de le dessiner avec des traits.',

  'tour.place.title': 'Placer les appareils',
  'tour.place.p1':
    'Placez le tableau de haut en bas : un **différentiel** (Q1), un **disjoncteur** (Q2) et une **prise** (X1). Tout s’aligne sur une grille de 2,5 mm.',
  'tour.place.p2':
    '**R** tourne et **M** retourne le symbole en cours de placement ou la sélection ; **Échap** repose l’outil.',
  'tour.place.tip':
    'Dessinez le tableau dans l’ordre où il se lit : alimentation, interrupteur général ou différentiel, disjoncteurs, puis les points. Gardez les repères donnés par Tablo : le multifilaire, la liste des circuits et les étiquettes du tableau en dépendent.',

  'tour.wire.title': 'Relier par des fils',
  'tour.wire.p1':
    'Appuyez sur **W**, cliquez sur une **borne** — l’extrémité du symbole s’allume quand vous êtes dessus — puis sur la borne suivante.',
  'tour.wire.p2':
    'Les coins sont tracés pour vous : reliez le différentiel au disjoncteur, puis le disjoncteur à la prise.',
  'tour.wire.p3':
    'Cliquez sur la grille libre pour ajouter un coin vous-même ; partez ou arrivez sur un fil pour une dérivation en T. **Retour arrière** enlève le dernier coin, **Échap** annule.',
  'tour.wire.tip':
    'Terminez toujours un fil sur une borne ou sur un autre fil, jamais juste à côté. Ce sont les connexions — pas le dessin — que lisent les circuits, les calculs et le contrôle : un fil qui a seulement l’air connecté ne l’est pas.',

  'tour.inspector.title': 'Régler les propriétés',
  'tour.inspector.p1':
    'Avec l’outil de sélection (**V**), cliquez sur un appareil : la section **Sélection** de la barre latérale montre son repère et tout ce qu’il porte — calibre, courbe, sensibilité, câble, référence catalogue, photos.',
  'tour.inspector.p2':
    'Ici, le disjoncteur passe en **20 A, courbe C**, et son étiquette sur la feuille suit. Un double-clic sur un appareil mène à son premier champ.',
  'tour.inspector.tip':
    'Indiquez les vraies valeurs, pas des valeurs provisoires. Calibres, courbes, sensibilités et câbles alimentent les calculs et le contrôle : rien n’est décoratif sur un schéma Tablo.',

  'tour.edit.title': 'Déplacer, copier, annuler',
  'tour.edit.p1': 'Faites glisser un appareil pour le déplacer : ses fils suivent.',
  'tour.edit.p2': '**{mod}Z** annule — la prise revient. **{mod}⇧Z** rétablit.',
  'tour.edit.p3':
    'Glissez sur une zone vide pour sélectionner (de gauche à droite : ce qui est entièrement dedans ; de droite à gauche : tout ce qui est touché). **Maj**-clic ajoute, **{mod}D** duplique, les flèches déplacent de 2,5 mm (10 avec Maj), **Suppr** efface.',
  'tour.edit.tip':
    'L’annulation garde les 500 dernières actions : essayez sans crainte. Enregistrez quand même avant les grosses opérations, comme générer des feuilles ou renuméroter : votre filet de sécurité, c’est le fichier, pas l’historique.',

  'tour.circuits.title': 'Le tableau des circuits',
  'tour.circuits.p1':
    '**Circuits** ouvre le tableau du coffret : une ligne par disjoncteur, avec sa description, son calibre, sa courbe, son différentiel, son câble, sa section, sa longueur, son mode de pose et ses points.',
  'tour.circuits.p2':
    'Modifiez une cellule et le schéma suit — ici, une description. Le tableau et la feuille sont deux vues du même coffret.',
  'tour.circuits.tip':
    'C’est la façon la plus rapide et la plus sûre de construire un schéma unifilaire. Dessinez la tête du tableau à la main si vous voulez, puis ajoutez et modifiez les circuits ici au lieu de les dessiner un par un.',

  'tour.addCircuit.title': 'Un circuit en un clic',
  'tour.addCircuit.p1':
    'Choisissez le différentiel sous lequel vient le circuit et son type — prises, éclairage ou un appareil — puis **Ajouter un circuit**.',
  'tour.addCircuit.p2':
    'Tablo dessine le disjoncteur, les points et le jeu de barres, fait de la place et met les valeurs habituelles : 16 A / 1,5 mm² pour l’éclairage, 20 A / 2,5 mm² pour les prises.',
  'tour.addCircuit.tip':
    'Placez chaque circuit sous le bon différentiel dès le départ : salle de bains, lave-linge, lave-vaisselle et sèche-linge sous le 30 mA. Limitez les circuits de prises à 8 points — le tableau les compte pour vous.',

  'tour.calc.title': 'Les calculs en direct',
  'tour.calc.p1':
    '**Ib** est le courant d’emploi ; **Iz**, ce que le câble supporte selon son isolant et son mode de pose.',
  'tour.calc.p2':
    '**ΔU** est la chute de tension (en général 3 % pour l’éclairage, 5 % pour le reste). Avec 28 m en 1,5 mm², le circuit d’éclairage ne passe pas : la valeur devient rouge.',
  'tour.calc.p3':
    '**L max** est la longueur maximale encore protégée contre les courts-circuits. Toute valeur en rouge ne passe pas.',
  'tour.calc.tip':
    'Indiquez les vraies longueurs de câble, mesurées sur le plan ou sur place : la chute de tension et la longueur maximale ne valent que ce que valent ces chiffres. Ce sont des aides à la conception — les mesures du contrôle décident.',

  'tour.renumber.title': 'Numéroter les circuits',
  'tour.renumber.p1':
    '**Numéroter les circuits** remet les codes dans l’ordre — A1, A2, A3… — après des ajouts, des déplacements ou des suppressions.',
  'tour.renumber.p2':
    'Chaque point porte le code de son circuit, le même sur l’unifilaire, le plan de position et les étiquettes du tableau.',
  'tour.renumber.tip':
    'Renumérotez une fois le tableau arrêté, avant de faire les plans, les étiquettes et le dossier de remise — pas après. Des codes qui changent alors que les documents sont sur le chantier, ce sont des erreurs assurées.',

  'tour.assistant.title': 'Demander à l’assistant IA',
  'tour.assistant.p1':
    '**IA → Assistant** ouvre la section **Assistant IA** de la barre latérale. Elle reste là pendant que vous dessinez et garde la conversation.',
  'tour.assistant.p2':
    'Tapez ou dictez une demande avec vos mots — plusieurs modifications à la fois si vous voulez — puis **Envoyer**.',
  'tour.assistant.p3':
    'Chaque réponse liste les modifications proposées et ce qu’en dirait le contrôle RGIE. **Appliquer** les fait en une fois, en une seule étape d’annulation.',
  'tour.assistant.tip':
    'Lisez la proposition avant de l’appliquer et vérifiez le résultat sur la feuille : l’assistant prépare, vous signez. Une demande claire à la fois donne les meilleurs résultats.',
  'tour.checks.title': 'Le contrôle RGIE',
  'tour.checks.p1':
    'Le panneau **Contrôle RGIE** liste les erreurs, avertissements et remarques, mis à jour à chaque modification.',
  'tour.checks.p2':
    'Chacun cite la règle, dit pourquoi et comment corriger ; cliquez dessus pour sélectionner ce qui est en cause. Les règles marquées **à confirmer** viennent de sources secondaires.',
  'tour.checks.p3': 'Le compteur de la barre d’état reste toujours visible.',
  'tour.checks.tip':
    'Gardez un œil sur le compteur pendant que vous dessinez et corrigez au fur et à mesure ; visez zéro erreur avant d’exporter. Le contrôle est une aide — l’organisme agréé reste seul juge.',

  'tour.multiline.title': 'Générer le schéma multifilaire',
  'tour.multiline.p1':
    '**Schéma → Générer le schéma multifilaire** le construit depuis l’unifilaire, sur une nouvelle feuille : bornier d’arrivée X0, interrupteur général, différentiels, barres, disjoncteurs et bornier de départ X1.',
  'tour.multiline.p2': 'Quand l’unifilaire change, ce bandeau propose **Mettre à jour**.',
  'tour.multiline.p3':
    'Le même menu numérote les fils et les bornes, attribue les références catalogue et fait l’implantation du tableau.',
  'tour.multiline.tip':
    'Ne redessinez jamais ce que Tablo peut générer. Faites la modification sur l’unifilaire et cliquez sur **Mettre à jour** : les retouches à la main sur une feuille générée sont remplacées.',

  'tour.sheets.title': 'Un projet, plusieurs feuilles',
  'tour.sheets.p1':
    'Le **+** après les onglets ajoute une feuille : unifilaire, multifilaire, **schéma de commande** (bobines et contacts liés par leur repère) ou **plan de position** (importez le plan en PDF, image ou DXF, réglez l’échelle, dessinez les pièces avec **P**, placez les points).',
  'tour.sheets.p2': 'Cliquez sur un onglet pour changer de feuille ; double-cliquez pour le renommer.',
  'tour.sheets.tip':
    'Une installation, un projet. Sur le plan de position, placez les points depuis la liste **À placer** plutôt que depuis la palette : ils gardent le code de leur circuit, et le plan correspond au schéma comme le demande le RGIE.',

  'tour.save.title': 'Enregistrer et remettre',
  'tour.save.p1': '**{mod}S** enregistre un fichier **.tablo** qui contient tout, plans et photos compris.',
  'tour.save.p2':
    '**Révisions** fige le projet en A, B… avec une description, affichée dans le cartouche ; **Comparer** montre ce qui a changé.',
  'tour.save.p3':
    '**Exporter — PDF + liste des circuits** produit le dossier complet ; devis, étiquettes et rapports sont dans le même menu.',
  'tour.save.p4':
    '**Se connecter** pour synchroniser vos appareils, travailler en équipe et partager un lien en lecture seule.',
  'tour.save.tip':
    'L’enregistrement automatique ne sert qu’à récupérer après un plantage ; ce n’est pas un stockage. Enregistrez le fichier ou mettez le projet en ligne, et figez une révision chaque fois qu’un schéma sort de vos mains : vous saurez toujours ce qui a changé depuis.',

  'tour.done.title': 'Vous êtes prêt',
  'tour.done.body':
    'Vous avez démarré un projet, dessiné un tableau à la main et avec le tableau des circuits, lu les calculs et le contrôle, et généré le multifilaire. Les habitudes qui paient :\n- partir d’un modèle ou d’un relevé ;\n- remplir d’abord les informations du projet ;\n- finir les fils sur des bornes et saisir les vraies valeurs ;\n- construire les circuits dans le tableau, renuméroter avant la remise ;\n- générer plutôt que redessiner, et cliquer sur Mettre à jour ;\n- enregistrer le fichier et figer une révision à chaque envoi.',
  'tour.done.tip':
    'Ouvrez **Fichier → Exemple** pour voir une maison complète, ou **Fichier → Nouveau depuis un modèle** pour votre premier vrai chantier. Après le chantier, le menu **Contrôle** reçoit les mesures, le rapport de l’organisme et la facture. Ce tutoriel reste dans **Fichier → Tutoriel guidé**.',
} as const;

export type MessageKey = keyof typeof fr;
export type Catalogue = Record<MessageKey, string>;
